import { render, staticRenderFns } from "./FormGenerator.vue?vue&type=template&id=a529717a&scoped=true&"
import script from "./FormGenerator.vue?vue&type=script&lang=ts&"
export * from "./FormGenerator.vue?vue&type=script&lang=ts&"
import style0 from "./FormGenerator.vue?vue&type=style&index=0&id=a529717a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a529717a",
  null
  
)

export default component.exports